import AddEditCompany from "@/apsales/Company/AddEditCompany";

export default function AddCompany() {
  return <AddEditCompany mode="add" />;
}